<div class="ig-block-navigator" *ngIf="items&&items.length">
    <div left class="ig-go" *ngIf="isNeedScroll" (click)="goLeft()">
        <mat-icon>chevron_left</mat-icon>
    </div>
    <div #wrap wrap class="flex" [class.no-margin]="!isNeedScroll&&!isMobile">
        <div *ngFor="let city of items" class="ig-city" [class.city-selected]="selected===city" (click)="cityClick(city)" matTooltip="View places in this city">
            <img [src]="imageService.safeImage(imageService.imageSourceUrl(city.cityImage, false))" width="170px" height="90px" alt="">
            <div title>{{city.cityTitle || city.title}}</div>
        </div>
    </div>
    <div right class="ig-go" *ngIf="isNeedScroll" (click)="goRight()">
        <mat-icon>chevron_right</mat-icon>
    </div>
</div>

<div *ngIf="!items||!items.length">
    <h1>No Cities in This Region...</h1>
</div>





// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/block.navigator/block.navigator.component.html